import { useState  } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NewNav.css";
import Logo from '../Images/logo.png'

const serviceLinks = [
  { label: "Engineering", path: "/engineering" },
  { label: "Construction", path: "/construction" },
  { label: "Commissioning", path: "/commissioning" },
  { label: "Manpower Supply", path: "/manpower-supply" },
  { label: "Procurement", path: "/procurement" },
  { label: "Installation and Instrumentation", path: "/installation-instrumentation" },
  { label: "Marine Support", path: "/marine-support" },
];

const aboutLinks = [
  { label: "Our Company", path: "/our-company" },
  { label: "Management", path: "/leadership" },
];

const navLinks = [
  { label: "Home", path: "/", hasDropdown: false },
  { label: "About Us", path: "/about", hasDropdown: true, dropdownType: "about" },
  { label: "Services", path: "/services", hasDropdown: true, dropdownType: "services" },
  { label: "Clients & Projects", path: "/projects", hasDropdown: false },
  { label: "Careers", path: "/career", hasDropdown: false },
  { label: "QHSE", path: "/qhse", hasDropdown: false },
  { label: "CSR", path: "/csr", hasDropdown: false },
  { label: "Contact Us", path: "/contact", hasDropdown: false },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  // const navigate = useNavigate();
  const location = useLocation();

  const closeAll = () => {
    setMobileOpen(false);
    setMobileServicesOpen(false);
    setMobileAboutOpen(false);
  };

  const renderDropdown = (type, links, isTwoColumn = false) => {
    const className = `navbar__dropdown${!isTwoColumn ? " navbar__dropdown--single" : ""}`;

    if (!isTwoColumn) {
      return (
        <div className={className} role="menu">
          {links.map((item) => (
            <Link
              key={item.label}
              to={item.path}
              className="navbar__dropdown-item"
              role="menuitem"
              onClick={closeAll}
            >
              {item.label}
            </Link>
          ))}
        </div>
      );
    }

    return (
      <div className={className} role="menu">
        <div className="navbar__dropdown-col">
          {links.slice(0, Math.ceil(links.length / 2)).map((s) => (
            <Link
              key={s.label}
              to={s.path}
              className="navbar__dropdown-item"
              role="menuitem"
              onClick={closeAll}
            >
              {s.label}
            </Link>
          ))}
        </div>
        <div className="navbar__dropdown-col">
          {links.slice(Math.ceil(links.length / 2)).map((s) => (
            <Link
              key={s.label}
              to={s.path}
              className="navbar__dropdown-item"
              role="menuitem"
              onClick={closeAll}
            >
              {s.label}
            </Link>
          ))}
        </div>
      </div>
    );
  };

  return (
    <header className="navbar">
      <div className="navbar__inner">
        {/* Logo */}
        <Link to="/" className="navbar__logo" onClick={closeAll}>
          <div className="navbar__logo-icon">
            <img src={Logo} alt="logo" />
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="navbar__nav" aria-label="Main navigation">
          <ul className="navbar__list">
            {navLinks.map((link) => {
              if (!link.hasDropdown) {
                return (
                  <li key={link.label} className="navbar__item">
                    <Link
                      to={link.path}
                      className={`navbar__link${location.pathname === link.path ? " navbar__link--active" : ""}`}
                      onClick={closeAll}
                    >
                      {link.label}
                    </Link>
                  </li>
                );
              }

              const isServices = link.dropdownType === "services";
              const links = isServices ? serviceLinks : aboutLinks;

              return (
                <li key={link.label} className="navbar__item navbar__item--dropdown">
                  <button
                    className={`navbar__link navbar__link--btn${location.pathname === link.path ? " navbar__link--active" : ""}`}
                    aria-haspopup="true"
                  >
                    {link.label}
                    <span className="navbar__caret">▾</span>
                  </button>

                  {/* Always rendered — CSS hover controls visibility */}
                  {renderDropdown(link.dropdownType, links, isServices)}
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Hamburger */}
        <button
          className="navbar__hamburger"
          onClick={() => setMobileOpen((o) => !o)}
          aria-label="Toggle menu"
          aria-expanded={mobileOpen}
        >
          <span className={`navbar__bar${mobileOpen ? " navbar__bar--open-1" : ""}`} />
          <span className={`navbar__bar${mobileOpen ? " navbar__bar--open-2" : ""}`} />
          <span className={`navbar__bar${mobileOpen ? " navbar__bar--open-3" : ""}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <nav className="navbar__mobile" aria-label="Mobile navigation">
          {navLinks.map((link) => {
            if (!link.hasDropdown) {
              return (
                <Link
                  key={link.label}
                  to={link.path}
                  className="navbar__mobile-link"
                  onClick={closeAll}
                >
                  {link.label}
                </Link>
              );
            }

            const isServices = link.dropdownType === "services";
            const isOpen = isServices ? mobileServicesOpen : mobileAboutOpen;
            const setOpen = isServices ? setMobileServicesOpen : setMobileAboutOpen;
            const links = isServices ? serviceLinks : aboutLinks;

            return (
              <div key={link.label}>
                <button
                  className="navbar__mobile-link navbar__mobile-link--btn"
                  onClick={() => setOpen((o) => !o)}
                >
                  {link.label} <span>{isOpen ? "▴" : "▾"}</span>
                </button>
                {isOpen &&
                  links.map((item) => (
                    <Link
                      key={item.label}
                      to={item.path}
                      className="navbar__mobile-sub"
                      onClick={closeAll}
                    >
                      {item.label}
                    </Link>
                  ))}
              </div>
            );
          })}
        </nav>
      )}
    </header>
  );
}